import { useQuery } from "@tanstack/react-query";
import { getRecentClientCount } from "@/api";
import { DashboardData } from "@/types";

export const useRecentClientCount = () => {
  const query = useQuery<DashboardData>({
    queryKey: ["recentClientCount"],
    queryFn: () => getRecentClientCount(),
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || null,
  }
};